import { render, staticRenderFns } from "./breastIntroduce.vue?vue&type=template&id=726c980a&scoped=true&"
import script from "./breastIntroduce.vue?vue&type=script&lang=js&"
export * from "./breastIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./breastIntroduce.vue?vue&type=style&index=0&id=726c980a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c980a",
  null
  
)

export default component.exports